// App.tsx
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from 'components/Header';
import Hero from 'components/Hero';
import Section1 from 'components/Section1';
import ModernLayout from 'components/ModernLayout';
import BuilderSection from 'components/BuilderSection';
import Section4 from 'components/Section4';
import FaqSection from 'components/FaqSection';
import Testimonial from 'components/Testimonial';
import Blog from 'components/Blog';
import TryUs from 'components/TryUs';
import Footer from 'components/Footer';
import Portfolio from 'pages/Portfolio';
import Contact from 'pages/Contact';
import Policy from 'pages/Policy';
import Blogs from 'pages/Blogs';
import Teams from 'pages/Teams';
import BlogDetail from './components/BlogDetail';
import Template from 'pages/Template';




const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Hero />
              <Section1 />
              <ModernLayout />
              <BuilderSection />
              <Section4 />
              <Blogs showFooter={false} limit={3} />
              <Testimonial />
              <FaqSection />
              <TryUs />
              <Footer />
            </>
          }
        />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/template" element={<Template />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:id" element={<BlogDetail />} />
        <Route path="/teams" element={<Teams />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
